<template>
	<div class="take-warp">
		<div class="electronic_content pzly">
			<div class="item" v-for="(item, index) in pzlyList" :key="index">
				<img :src="imgAllPath(item.img)" alt />
				<h3>{{ item.name }}</h3>
				<p>{{ item.content }}</p>
			</div>
		</div>
		<section>
			<div class="btn-warp">
				<p>
					<el-button :disabled="uploadStatus" size="medium" v-if="!token" type="primary" @click="uploadBtn" style="width:136px;height:48px"><img class="upload-icon"
								src="@comm/images/document-conversion/electronic/upload.png" alt="" /><span class="fnt16">上传文件</span>
						</el-button>
					<el-upload class="upload-demo" ref="upload" v-else accept=".ofd" action="#" :show-file-list="false"
						:on-change="handleChange" :before-upload="beforeUpload" :http-request="handleUploadFile" :disabled="uploadStatus">
						<el-button :disabled="uploadStatus" size="medium" type="primary" style="width:136px;height:48px"><img class="upload-icon"
								src="@comm/images/document-conversion/electronic/upload.png" alt="" /><span class="fnt16">上传文件</span>
						</el-button>
					</el-upload>
				</p>
				<ul class="btn-warp-list">
					<li>
						<el-button type="primary" size="small" :disabled="!uploadInfo.signature"
							@click="handleClickBtn(1)">签章验证</el-button>
					</li>
					<li>
						<el-button type="primary" size="small" :disabled="!uploadInfo.metaData"
							@click="handleClickBtn(2)">提取元数据</el-button>
					</li>
					<li>
						<el-button type="primary" size="small" :disabled="!uploadInfo.xbrl" @click="handleClickBtn(3)">
							提取XBRL</el-button>
					</li>
					<li>
						<el-button type="primary" size="small" @click="handleClickBtn(4)">下载图片</el-button>
					</li>
				</ul>
			</div>
			<div class="reader-warp">
				<div class="reader_header">
					<div class="left">
						<img src="@comm/images/document-conversion/zxyl/ofd_icon.png" />
						<a :title="fileName">{{ fileName | limitFileName(20, true) }}</a>
					</div>
					<div class="right">
						<div @click="printBth">
							<img src="@comm/images/document-conversion/zxyl/dy_icon.png" />
							打印
						</div>
						<div @click="handleCheck">
							<img src="@comm/images/document-conversion/zxyl/phone_icon.png" />

							手机查看
						</div>
						<div @click="moreBtn">
							<img src="@comm/images/document-conversion/zxyl/more_icon.png" />
							更多
						</div>
						<div class="qrcode_box" v-if="showPhone">
							<div class="qrcode_body">
								<p class="name">手机扫描二维码预览文件</p>
								<div class="qrcode_main">
									<div id="qrcode" class="qrcode" ref="qrcode"></div>
									<div class="qrcode_cover"></div>
								</div>
								<a class="sname" :title="fileName+'.ofd'">{{ fileName | limitFileName(10,true) }}.ofd</a>
								<p class="size">文档大小：{{ fileSize }}</p>
								<div class="closed_btn" @click="showPhone = false"></div>
							</div>
						</div>
						<div class="more_box" v-if="showMore">
							<div class="qrcode_body">
								<div class="list" @click="helpBtn">帮助</div>
								<div class="list" @click="feedBtn">意见反馈</div>
								<div class="list" @click="aboutBtn">关于</div>
							</div>
						</div>
					</div>
				</div>
			<div class="reader_content">
				<iframe id="web-reader" ref="iframe" :src="iframeUrl" frameborder="0"
					allowfullscreen="true"></iframe>
			</div>
		</div>
		</section>
		<ContantHead :title="['上传文件预览凭证', '签章验证', '提取元数据', '提取XBRL']" />
		<signature-dialog :show.sync="signatureDialog" :seal-info-list.sync="sealInfoList"
			:verify-result.sync="verifyResult" />
			<feed-back :showFeedDialog="showFeedDialog" @closed="closedFeedDialog"></feed-back>
    <about-read :showReadDialog="showReadDialog" @closed="closedReadDialog"></about-read>
	</div>
</template>

<script>
import { uploadFile, extractMetadata, extractXBRLdata, verifySignature, downloadPicture, checkIssueData } from "@comm/api/document-conversion/usetake";
import ContantHead from "./components/ContantHead";
import SignatureDialog from "./components/SignatureDialog";
import { exportBlobData,getfilesize } from "@comm/utils/tools";
import feedBack from "@comm/components/document-conversion/feedback";
import aboutRead from "@comm/components/document-conversion/aboutRead";
import { Base64 } from "js-base64";
import common from "@comm/utils/common";
import QRCode from "qrcodejs2";
export default {
	name: "VoucherUse",
	components: { ContantHead, SignatureDialog, feedBack, aboutRead},
	props: {
		token: { type: String, default: "" }
	},
	data() {
		return {
			iframeUrl: "",
			uploadStatus: false,
			uploadInfo: {
				metaData: true,
				signature: true,
				xbrl: true,
				fileId: "1"
			},
			signatureDialog: false,
			sealInfoList: [],
			verifyResult: [],
			// 按钮loading
			loading1: false,
			loading2: false,
			loading3: false,
			loading4: false,
			pzlyList: [
				{ img: 'pzly_06.png', name: '凭证阅览', content: '支持跨平台跨设备多终端阅览' },
				{ img: 'pzly_07.png', name: '签章验证', content: '支持验证凭证签章的真伪，提供凭证签章批量验证' },
				{ img: 'pzly_08.png', name: '结构化数据提取', content: '精准解析OFD凭证的结构化数据，并进行数据提取' },
				{ img: 'pzly_09.png', name: 'XBRL服务', content: '支持生成XBRL附件，提取XBRL附件到指定位置，支持XBRL与JSON格式数据互转' },
				{ img: 'pzly_10.png', name: '水印、注释应用', content: '支持凭证在使用中添加水印说明，条形码、归档章、图章等' }
			],
			fileName: 'XXXX银行电子回单',
			showFeedDialog: false,
            showReadDialog: false,
			showMore:false,
			showPhone:false,
			fileSize: '209.3K',
			isUpload:false,
		};
	},
	computed: {
		hasUpload() {
			return !!Object.keys(this.uploadInfo).length;
		},
		uploadSourceFromIssue() {
			return this.$store.getters.uploadSourceFromIssue;
		},
		imgAllPath() {
			return function (img) {
				return require(`@comm/images/document-conversion/electronicDocuments/${img}`);
			};
		},
	},
	created() {
        if (this.uploadSourceFromIssue) {
            const { fileName, filePath, fileId, fileSize } = this.$store.state.uploadFromIssue;
            let nameLength = fileName.lastIndexOf('.')
            this.fileName = fileName.substring(0, nameLength)
            this.fileSize=fileSize ? getfilesize(fileSize) : "0M";
            // const baseUrl = encodeURIComponent(Base64.encode(fileName + "|" + filePath));
            // this.iframeUrl = common.baseurl + "?file=" + baseUrl;
 			const concatURL = encodeURIComponent(`${common.apiUrl}/pubservice/file/info?ticket=${fileId}`);
            this.iframeUrl = common.baseurl + "?file=" + concatURL;

            checkIssueData({ fileId }).then((res) => {
                const { metaData, signature, xbrl } = res.data;
                this.uploadInfo = { fileId, fileName, filePath, metaData, signature, xbrl };
            });
        } else {
			const concatURL = encodeURIComponent(`${common.apiUrl}/pubservice/file/info?ticket=123456`);
			this.iframeUrl = `${common.baseurl}?file=${concatURL}&viewMode=mix&type=onlinePreview`;
		}
	},
	methods: {
		uploadBtn() {
			if (!this.token) {
				let path = this.$route.path;
				window.open(
					`https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
					"_self"
				);
				return
			}
		},
		feedBtn() {
            this.showMore = false
            this.showFeedDialog = true;
        },
        aboutBtn() {
            this.showMore = false
            this.showReadDialog = true;
        },
        closedFeedDialog(data) {
            this.showFeedDialog = data;
        },
        closedReadDialog(data) {
            this.showReadDialog = data;
        },
        printBth() {
            this.showPhone = false;
            this.showMore = false;
            this.$refs.iframe.contentWindow.postMessage(["click", "print"], "*");
        },
        handleCheck() {
            this.showPhone = !this.showPhone;
            this.showMore = false
            if (this.showPhone) {
                this.$nextTick(() => {
                    this.makeQrcode(this.iframeUrl);
                });
            }
        },
		helpBtn() {
            this.showMore = false
            window.open("http://suwell.cn/", "_blank");
        },
        moreBtn() {
            this.showMore = !this.showMore
            this.showPhone = false
        },
        makeQrcode(text) {
            new QRCode("qrcode", {
                width: 142, // 设置宽度，单位像素
                height: 142, // 设置高度，单位像素
				correctLevel: 3,
                text // 设置二维码内容或跳转地址
            });
        },
		handleClickBtn(type) {
			if (!this.hasUpload) return;
			let reqData = {};
			let isUpload = this.isUpload
			if (this.uploadSourceFromIssue) {
				const { fileId } = this.$store.state.uploadFromIssue;
				reqData = { fileId, type: "1" };
			} else {
				const { fileId } = this.uploadInfo;
				reqData = { fileId };
			}
			switch (type) {
				case 1:
					this.signatureVerify(reqData);
					break;
				case 2:
					if (this.loading2) return;
					this.loading2 = true;
					extractMetadata(reqData,isUpload)
						.then((res) => {
							exportBlobData(res);
						})
						.finally(() => (this.loading2 = false));
					break;
				case 3:
					if (this.loading3) return;
					this.loading3 = true;
					extractXBRLdata(reqData,isUpload)
						.then((res) => {
							exportBlobData(res);
						})
						.finally(() => (this.loading3 = false));
					break;
				case 4:
					if (this.loading4) return;
					this.loading4 = true;
					downloadPicture(reqData,isUpload)
						.then((res) => {
							exportBlobData(res);
						})
						.finally(() => (this.loading4 = false));
			}
		},
		// 签章验证
		signatureVerify(reqData) {
			if (this.loading1) return;
			this.loading1 = true;
			verifySignature(reqData,this.isUpload)
				.then((res) => {
					const { signature, verify } = res.data;
					this.signatureDialog = true;
					this.sealInfoList = signature;
					let verifyResultData = []
					let verifyResult = verify
					verifyResult.forEach((item, index) => {
						item.name = this.sealInfoList[index] ? (this.sealInfoList[index].type=='Sign'?this.sealInfoList[index].signCert.subjectInfo.commonName:this.sealInfoList[index].sealName) : null;
						item.img = this.sealInfoList[index].type=='Sign'?require("@comm/images/document-conversion/electronic/qm_icon.png"): "data:image/png;base64," + this.sealInfoList[index].sealImage.pictureData;
						item.type = this.sealInfoList[index].type
						item.index=index
						if(item.type!='TimeStamp'){
							verifyResultData.push(item)
						}
					});
					this.verifyResult=verifyResultData
				})
				.finally(() => (this.loading1 = false));
		},
		// ------
		// 上传文件
		handleUploadFile(params) {
			const file = params.file;
			if (file.size === 0) {
				this.$confirm("上传文件大小不能为空!", "", {
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "error",
					customClass: "custom-notitle-confirm"
				});
				return;
			}
			const isLt5M = file.size / 1024 / 1024 < 5;
			if (!isLt5M) {
				this.$confirm("您选择的文件总大小超过5M，请重新选择！", "", {
					cancelButtonText: "取消",
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "warning",
					showClose: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					lockScroll: false
				}).then(() => {
					return;
				});
				return;
			}

			this.$store.commit("SET_UPLOADSOURCE", false);
			this.uploadStatus = true;

			const formData = new FormData();
			formData.append("multipartFile", file);
			uploadFile(formData)
			.then((res) => {
                    // const { fileName, filePath } = res.data;
                    const { fileId } = res.data;
                    this.uploadInfo = res.data;
                    this.$message.success("上传成功！");
                    this.$refs.upload.clearFiles();
                    this.isUpload=true
                    let nameLength = this.uploadInfo.fileName.lastIndexOf('.')
                    this.fileName = this.uploadInfo.fileName.substring(0, nameLength)
                    this.fileSize=this.uploadInfo.fileSize ? getfilesize(this.uploadInfo.fileSize) : "0M";
                    // const baseUrl = encodeURIComponent(Base64.encode(fileName + "|" + filePath));
                    // this.iframeUrl = common.baseurl + "?file=" + baseUrl;

					const concatURL = encodeURIComponent(`${common.apiUrl}/pubservice/file/info?ticket=${fileId}`);
            		this.iframeUrl = common.baseurl + "?file=" + concatURL;
                })
                .catch(() => {
                    this.$refs.upload.clearFiles();
                    this.isUpload=false
                })
				.finally(() => (this.uploadStatus = false));
		},
		// 上传前校验
		beforeUpload(file) {
			this.showPhone = false;
            this.showMore = false
			let extName = "";
			let AllUpExt = ".ofd|";
			extName = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
			if (AllUpExt.indexOf(extName + "|") == "-1") {
				this.$message.error("文件格式错误");
				this.uploadStatus = false;
				return false;
			}
			// const reg = /^application\/(\w|-)*ofd$/gi;
			// if (!reg.test(file.type)) {
			// 	this.$message.error("文件格式错误");
			// 	this.uploadStatus = false;
			// 	return false;
			// }
			const isLt5M = file.size / 1024 / 1024 < 5;
			if (!isLt5M) {
				this.$confirm("您选择的文件总大小超过5M，请重新选择！", "", {
					cancelButtonText: "取消",
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "warning",
					showClose: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					lockScroll: false
				}).then(() => {
					return;
				});
				return isLt5M;
			}
		},
		handleChange(file, fileList) { }
	}
};
</script>

<style lang="scss" scoped>
.take-warp {
	width: 1200px;
}

.pzly {
	margin: 49px 0 64px;
}

.btn-warp {
	width: 100%;
	height: auto;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	margin-bottom: 24px;

	ul {
		overflow: hidden;

		li {
			float: left;
			margin-right: 24px;
		}

		&>li:nth-last-child(1) {
			margin: 0;
		}
	}
}

.reader-warp {
	width: 100%;
	height: 620px;
	border: 1px solid #d0d0d0;
	display: flex;
    flex-direction: column;

	.reader_header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 44px;
		background: #f5f5f5;
		padding: 0 15px 0 10px;
		border-bottom: 1px solid #eaeaea;

		.right {
			position: relative;
			display: flex;
			justify-content: space-between;
			align-items: center;

			>div:not(.more_box) {
				padding: 5px 0;
				margin-left: 15px;
				font-size: 12px;
				color: #36425A;
				line-height: 17px;

				img {
					width: 24px;
					height: 24px;
				}

				&:hover {
					cursor: pointer;
					// background: #e4e4e4;
					border-radius: 2px;
				}
			}

			.more_box {
				position: absolute;
				right: 15px;
				top: 44px;

				.qrcode_body {
					display: flex;
					justify-content: flex-start;
					flex-direction: column;
					align-items: center;
					width: 139px;
					height: 82px;
					border-radius: 2px;
					padding: 5px 0;
					border: 1px solid #ccc;
					background-color: #fff;

					.list {
						height: 24px;
						padding: 0 23px;
						line-height: 24px;
						font-size: 12px;
						color: #333;
						width: 100%;
						cursor: pointer;

						&:hover {
							background: #f5f5f5;
						}
					}
				}
			}
		}

		img {
			width: 32px;
			height: 32px;
			vertical-align: middle;
		}
	}

	.reader_content {
		height: 100%;
		background-color: #E7E7E7;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			height: 100%;
		}
	}
}

#web-reader {
	width: 100%;
	height: 100%;
}

.upload-icon {
	width: 16px;
	height: 15px;
	vertical-align: -2px;
	margin-right: 4px;
}
.qrcode_box {
    width: 198px;
    height: 246px;
    background: #ffffff;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 44px;
    right: 32px;
    z-index: 999;

    &:hover {
        background: #ffffff;
    }

    &.more_box {
        position: absolute;
        width: 139px;
        height: 82px;
        border-radius: 2px;
        border: 1px solid #cccccc;
        right: 15px;

        .qrcode_body {
            padding: 5px 0;
            align-items: flex-start;
            background: #fff;

            .list {
                height: 24px;
                padding: 0 23px;
                line-height: 24px;
                font-size: 12px;
                color: #333333;
                width: 100%;
                cursor: pointer;

                &:hover {
                    background: #f5f5f5;
                }
            }
        }
    }

    .qrcode_body {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;

        &:hover {
            background: #ffffff;
        }

        .qrcode_main {
            width: 150px;
            height: 150px;
            border: 1px solid #e7e7e7;
            margin: 4px 0;
            position: relative;

            .qrcode {
                margin: 4px auto;
                width: 142px;
                height: 142px;
            }

            .qrcode_cover {
                width: 142px;
                height: 142px;
                position: absolute;
                top: 4px;
                left: 4px;
                background: transparent;
            }
        }

        .closed_btn {
            position: absolute;
            top: 15px;
            right: 15px;
            width: 17px;
            height: 16px;
            background: url("../../../images/document-conversion/zxyl/close_btn.png") 0 0 no-repeat;
            background-size: 100%;
        }

        .name {
            font-size: 12px;
            color: #333333;
            line-height: 16px;
            margin-top: 28px;
        }

        .sname {
            font-size: 12px;
            color: #008ad9;
            line-height: 18px;
            text-decoration: none;
        }

        .size {
            font-size: 12px;
            color: #b1b1b1;
            line-height: 18px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/electronicDec/Usetake.vue